import { createSlice } from '@reduxjs/toolkit';
import { emptyFetchState } from '../emptyState';
import { fetchStatus } from '../status';
import { getAndroidGeneratedInput } from 'api';

// Then, handle actions in your reducers:
const androidUnapprovedGeneratedInputSlice = createSlice({
  name: 'androidUnapprovedGeneratedInput',
  emptyFetchState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    androidUnapprovedGeneratedInputFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    androidUnapprovedGeneratedInputFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    androidUnapprovedGeneratedInputFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    androidUnapprovedGeneratedInputResetState: (state) => {
      state.payload = null;
      state.fetching = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  androidUnapprovedGeneratedInputFetchStart,
  androidUnapprovedGeneratedInputFetchSuccess,
  androidUnapprovedGeneratedInputFetchFail,
  androidUnapprovedGeneratedInputResetState,
} = androidUnapprovedGeneratedInputSlice.actions;

// The reducer
export const androidUnapprovedGeneratedInputReducer = androidUnapprovedGeneratedInputSlice.reducer;

// Asynchronous thunk action
export const androidUnapprovedGeneratedInputFetch = (data: Object) => (dispatch) => {
  dispatch(androidUnapprovedGeneratedInputFetchStart());

  getAndroidGeneratedInput(data)
    .then((androidGeneratedInput) => {
      dispatch(androidUnapprovedGeneratedInputFetchSuccess(androidGeneratedInput.data));
    })
    .catch((error) => {
      dispatch(androidUnapprovedGeneratedInputFetchFail(error));
    });
};
